module.exports = __webpack_public_path__ + "static/media/scoristaIcon.b9dad724.webp";